import { render, staticRenderFns } from "./TransportationPermissionsMapper.vue?vue&type=template&id=df73038a"
import script from "./TransportationPermissionsMapper.vue?vue&type=script&lang=ts"
export * from "./TransportationPermissionsMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports